import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d88ca7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "w-full h-full bg-white border-round-3xl grid justify-content-center align-content-start"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 0,
  class: "col-12 flex p-0 m-0"
}
const _hoisted_4 = {
  class: "m-auto",
  style: {"font-size":"10px"}
}
const _hoisted_5 = { class: "col-12 px-2 pb-1 grid align-content-around justify-content-center" }

import { Game } from "@/interfaces/Game";
import { computed } from "vue";
import UsaResultBoard from "./UsaResultBoard.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RdUsaGameBoard',
  props: {
    info: {},
    showName: { type: Boolean },
    inline: { type: Boolean },
    isToday: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



const timeMORNING = computed(() => props.info?.result.MORNING?.filter((e) => e.time !== "").map((e) => e.time));
const timeDAY = computed(() => props.info?.result.DAY?.filter((e) => e.time !== "").map((e) => e.time));
const timeDAYTIME = computed(() => props.info?.result.DAYTIME?.filter((e) => e.time !== "").map((e) => e.time));
const timeMIDDAY = computed(() => props.info?.result.MIDDAY?.filter((e) => e.time !== "").map((e) => e.time));
const timeEVENING = computed(() => props.info?.result.EVENING?.filter((e) => e.time !== "").map((e) => e.time));
const timeNIGHT = computed(() => props.info?.result.NIGHT?.filter((e) => e.time !== "").map((e) => e.time));

return (_ctx: any,_cache: any) => {
  return (_ctx.info)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("img", {
          src: _ctx.info.logo,
          class: "rectangle-logo border-3 border-white bg-white"
        }, null, 8, _hoisted_2),
        (_ctx.showName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("strong", _hoisted_4, _toDisplayString(_ctx.info.states), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.info.result.MORNING)
            ? (_openBlock(), _createBlock(UsaResultBoard, {
                key: 0,
                boloSize: 15,
                todHeight: 20,
                results: _ctx.info.result.MORNING,
                tod: "MORNING",
                time: timeMORNING.value,
                icon: "pi pi-sun text-yellow-500",
                inline: _ctx.inline ?? true,
                isToday: _ctx.isToday
              }, null, 8, ["results", "time", "inline", "isToday"]))
            : _createCommentVNode("", true),
          (_ctx.info.result.DAY)
            ? (_openBlock(), _createBlock(UsaResultBoard, {
                key: 1,
                boloSize: 15,
                todHeight: 20,
                results: _ctx.info.result.DAY,
                tod: "MIDDAY",
                time: timeDAY.value,
                icon: "pi pi-sun text-yellow-500",
                inline: _ctx.inline ?? true,
                isToday: _ctx.isToday
              }, null, 8, ["results", "time", "inline", "isToday"]))
            : _createCommentVNode("", true),
          (_ctx.info.result.DAYTIME)
            ? (_openBlock(), _createBlock(UsaResultBoard, {
                key: 2,
                boloSize: 15,
                todHeight: 20,
                results: _ctx.info.result.DAYTIME,
                tod: "MIDDAY",
                time: timeDAYTIME.value,
                icon: "pi pi-sun text-yellow-500",
                inline: _ctx.inline ?? true,
                isToday: _ctx.isToday
              }, null, 8, ["results", "time", "inline", "isToday"]))
            : _createCommentVNode("", true),
          (_ctx.info.result.MIDDAY)
            ? (_openBlock(), _createBlock(UsaResultBoard, {
                key: 3,
                boloSize: 15,
                todHeight: 20,
                results: _ctx.info.result.MIDDAY,
                tod: "MIDDAY",
                time: timeMIDDAY.value,
                icon: "pi pi-sun text-yellow-500",
                inline: _ctx.inline ?? true,
                isToday: _ctx.isToday
              }, null, 8, ["results", "time", "inline", "isToday"]))
            : _createCommentVNode("", true),
          (_ctx.info.result.EVENING)
            ? (_openBlock(), _createBlock(UsaResultBoard, {
                key: 4,
                boloSize: 15,
                todHeight: 20,
                results: _ctx.info.result.EVENING,
                tod: "EVENING",
                time: timeEVENING.value,
                icon: "pi pi-moon text-surface-300",
                inline: _ctx.inline ?? true,
                isToday: _ctx.isToday
              }, null, 8, ["results", "time", "inline", "isToday"]))
            : _createCommentVNode("", true),
          (_ctx.info.result.NIGHT)
            ? (_openBlock(), _createBlock(UsaResultBoard, {
                key: 5,
                boloSize: 15,
                todHeight: 20,
                results: _ctx.info.result.NIGHT,
                tod: "NIGHT",
                time: timeNIGHT.value,
                icon: "pi pi-moon text-surface-300",
                inline: _ctx.inline ?? true,
                isToday: _ctx.isToday
              }, null, 8, ["results", "time", "inline", "isToday"]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})